import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from '../utils';

const FormAddressAutoCompleteElement = {
  group: ELEMENT_GROUPS.FORMS,
  label: 'Address Auto-Complete',
  icon: 'DocumentTextIcon',
  description:
    'Adds a control that auto-completes addresses using Google Places API and puts it into the local store',
  properties: [
    'layout',
    'margin',
    'padding',
    'alignment',
    {
      label: 'Address Selected Action',
      name: 'action',
      editor: 'dropdown',
      default: '',
      description: 'An action to run when an address is selected',
      options: [],
      function: {
        name: 'getAppActions',
        params: ['app.id']
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Background Color',
      name: 'backgroundColor',
      editor: 'color',
      description: 'The background color of the element',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Disabled',
      default: false,
      name: 'disabled',
      editor: 'switch',
      description: 'If the field is disabled',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Border Color',
      name: 'borderColor',
      editor: 'color',
      description: 'The border color of the date and label',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Border Width',
      name: 'borderWidth',
      editor: 'number',
      description: 'The border width of the date and label',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Google Places API Key',
      name: 'apiKey',
      editor: 'textbox',
      description:
        'See https://github.com/FaridSafi/react-native-google-places-autocomplete',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Placeholder Text',
      name: 'placeholder',
      editor: 'textbox',
      description: 'The placeholder to display in the field',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Local Store Key',
      name: 'localStoreKey',
      editor: 'textbox',
      description:
        'A key in the local store that will be used to store the json result of the selected address i.e. { line1, line2, city, county, postcode, country }',
      default: 'selectedAddress',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Custom Error Message',
      name: 'customErrorMessage',
      default: '',
      editor: 'textbox',
      description: 'Custom Error Message',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Error Message Color',
      name: 'errorMessageColor',
      default: '#000000',
      editor: 'colorpicker',
      description: 'The color of the error message',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Error Message Font',
      name: 'errorMessageFont',
      editor: 'fontsize',
      description: 'The color of the error message',
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Error Message Alignment',
      name: 'errorMessageAlignment',
      editor: 'alignment',
      description: 'The alignment error message',
      default: 'justify-left',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Error Message Margin',
      name: 'errorMessageMargin',
      editor: 'boundary',
      description: 'The margin around the error message',
      default: '10 0 10 0',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Error Message Padding',
      name: 'errorMessagePadding',
      editor: 'boundary',
      description: 'The padding within the error message',
      default: '10 10 10 10',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    }
  ]
};

export default FormAddressAutoCompleteElement;
